import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import _, { get, toSafeInteger } from "lodash"
import classnames from "classnames"

import BadgeFixedVoice from "../../../components/Inputs/BadgeFixedVoice"
import SpinnerLoad from "../../../components/SpinnerLoad"
import Typograph from "../../../../../components/Typograph"

import styles from "./styles.css"

import {
  getStatusAssetCount,
  getStatusOrdersCount
} from "services/state/fixedVoice/action"
import { statusAssets, statusOrders } from "./constants"

import phone from "../../../../../assets/svg/fixed_voice_situation.svg"

const getStatusList = (statusLabels, status) => {
  return _.map(statusLabels, (value) => {
    const statusValue = get(status, `${value.key}`, 0)
    return { ...value, value: toSafeInteger(statusValue) }
  })
}

const ClientDetailsDash = ({
  customer,
  status,
  type,
  filter,
  loading,
  getStatusAssetCount,
  getStatusOrdersCount
}) => {
  const [statusSelected, setStatusSelected] = useState()
  const customerName = get(customer, "name", "Não informado")
  const customerDocument = get(customer, "document", "Não informado")
  const numbers = get(customer, "numbers", "Não informado")
  const customerStatus = get(customer, "status", "")
  const isAsset = type === "ASSET"

  const statusList = isAsset
    ? getStatusList(statusAssets, status)
    : getStatusList(statusOrders, status)

  const filterByStatus = (key, status) => {
    const statusName = _.upperCase(get(status, "name", ""))
    const statusKey = get(status, "key", "")

    filter({
      page: 1,
      status: isAsset ? _.deburr(statusName) : statusKey
    })

    setStatusSelected(statusKey)
  }

  useEffect(() => {
    const customerDocument = get(customer, "document", null)

    if (!customerDocument) {
      return
    }

    if (isAsset) {
      getStatusAssetCount(customerDocument)
    } else {
      getStatusOrdersCount(customerDocument)
    }
  }, [customer, type])

  return (
    <div className={styles.box_fixed_dash}>
      <div className={styles.container_client}>
        <div>
          <div className={classnames(styles.space_align, styles.margin)}>
            <Typograph
              htmlTag="span"
              size="medium"
              color="outer_space"
              weight="bold"
            >
              {customerName}
            </Typograph>

            <div className={styles.badge}>
              <BadgeFixedVoice
                type={customerStatus}
                data={_.capitalize(customerStatus)}
              />
            </div>
          </div>
          <div className={styles.document}>
            <Typograph
              htmlTag="span"
              size="small"
              color="outer_space"
              weight="medium"
            >
              {customerDocument && customerDocument.length > 11
                ? "CNPJ"
                : "CPF"}
              : {customerDocument}
            </Typograph>
          </div>
        </div>

        <div className={`${styles.space_align} ${styles.numbers_situation}`}>
          <div className={`${styles.title_flex}`}>
            <div className={styles.img_flex}>
              <img src={phone} alt={"icon phone"} />
            </div>
            <Typograph
              htmlTag="span"
              size="medium"
              color="outer_space"
              weight="bold"
            >
              Situação dos números
            </Typograph>
          </div>
          <div className={styles.numbers}>
            <Typograph
              htmlTag="span"
              size="medium"
              color="nevada_gray"
              weight="bold"
            >
              Números adquiridos:{" "}
            </Typograph>

            <Typograph
              htmlTag="span"
              size="medium"
              color="outer_space"
              weight="bold"
            >
              {numbers}
            </Typograph>
          </div>
        </div>
        {loading ? (
          <div className={styles.loading_spinner}>
            <SpinnerLoad />
          </div>
        ) : (
          <div className={`${styles.status_space} ${styles.status_direction}`}>
            {statusList &&
              statusList.map((value, key) => {
                return (
                  <div
                    className={`${styles.status_item} ${
                      value.key === statusSelected && styles.status_selected
                    }`}
                    key={key}
                    onClick={() => filterByStatus(key, value)}
                  >
                    <Typograph
                      htmlTag="span"
                      size="small"
                      color="outer_space"
                      weight="bold"
                      classNames={styles.statusText}
                    >
                      {value.name}
                    </Typograph>

                    <BadgeFixedVoice
                      isDash
                      type={value.key}
                      data={value.value}
                      isDataNumber
                    />
                  </div>
                )
              })}
          </div>
        )}
      </div>
    </div>
  )
}

ClientDetailsDash.propTypes = {
  customer: PropTypes.object,
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  filter: PropTypes.func,
  loading: PropTypes.bool,
  getStatusAssetCount: PropTypes.func,
  getStatusOrdersCount: PropTypes.func
}

const mapStateToProps = ({ customersFixedVoice }) => ({
  status: customersFixedVoice.status,
  loading: customersFixedVoice.loading
})

const mapActionsToProps = {
  getStatusAssetCount,
  getStatusOrdersCount
}

export default connect(mapStateToProps, mapActionsToProps)(ClientDetailsDash)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ClientDetails/ClientDetailsDash/index.js